import React from 'react';
import styled from 'styled-components';
import {Body} from '../../../components/Typography';

export const Wrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  grid-gap: 8px;

  @media (max-width: 480px) {
    grid-template-rows: 32px 1fr;
    grid-gap: 0px;
  }
  @media (max-width: 409px) {
    grid-template-rows: auto 1fr;
  }
`;

export const IconWrapper = styled.div`
  @media (max-width: 479px) {
    display: none;
  }
`;

export const Text = styled(Body)`
  color: ${props => props.theme.orderStatusProgressTextColor};
`;

export const Image = styled.img`
  max-width: 45px;
  vertical-align: text-bottom;
`;
